<div *transloco="let t; read: 'action-item-editor'" class="action-item-editor__container">
  @if (isInNoneMode) {
    <div class="action-item-editor__none-text">{{ t('no-action-item') }}</div>
  } @else {
    <div class="action-item-editor__editor">
      <form [formGroup]="form" class="action-item-editor__form">
        <xi-input-field [label]="t('name')" formControlName="name"></xi-input-field>
        <xi-input-field [label]="t('assignee')" formControlName="assignee"></xi-input-field>
        <xi-date-picker
          [label]="t('due')"
          [minDate]="minDueDate"
          formControlName="dueDate"
        ></xi-date-picker>
        <xi-dropdown [label]="t('status')" formControlName="status" [data]="statusDs"></xi-dropdown>
        <xi-text-area formControlName="notes" [placeholder]="t('notes-placeholder')" type="text">
        </xi-text-area>
      </form>
      <div class="action-item-editor__actions">
        <div class="action-item-editor__actions-left">
          <xi-default-button
            [text]="t('delete')"
            [disabled]="isDeleteDisabled"
            color="error"
            (onClick)="onDelete()"
          ></xi-default-button>
        </div>
        <div class="action-item-editor__actions-right">
          <xi-default-button
            [text]="t('cancel')"
            [disabled]="isCancelDisabled"
            fill="text"
            (onClick)="onCancel()"
          ></xi-default-button>
          <xi-default-button
            [text]="t('save')"
            [disabled]="isSaveDisabled"
            (onClick)="onSave()"
          ></xi-default-button>
        </div>
      </div>
    </div>
  }
</div>
